import { render } from "./MenuUp.vue?vue&type=template&id=6f2fa4ce"
import script from "./MenuUp.vue?vue&type=script&lang=js"
export * from "./MenuUp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__